












import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class CellAddress extends Vue {
    @Prop(Object) private value ?: object;
    @Prop({type: String, default: 'text'}) private type ?: string;

    @Emit('onSelect')
    private select() {
        return this.value;
    }
}
